module.exports = __webpack_public_path__ + "static/media/ajax-Loader.c8857175.gif";